module.exports = __webpack_public_path__ + "officialStatic/img/news5.5c50bc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/news5.png
// module id = fWOU
// module chunks = 0